export default __webpack_public_path__ + "static/media/weather.19dfc789.jpg";